import MDTypography from 'components/MDTypography';
import { ConfirmModal } from 'shared/modals/confirmModal';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const propTypes = {
  exceedUploadMissionsLimit: PropTypes.bool.isRequired,
  handleExceedUploadMissionsLimitClose: PropTypes.func.isRequired,
};

const ExceededLimitModal = ({
  exceedUploadMissionsLimit,
  handleExceedUploadMissionsLimitClose,
}) => {
  return (
    <ConfirmModal
      isOpened={exceedUploadMissionsLimit}
      title={intl.get('new_modal_exceed_upload_limit_message_1')}
      bodyText={intl.get('new_modal_exceed_upload_limit_message_2')}
      onConfirm={handleExceedUploadMissionsLimitClose}
      confirmButtonText={intl.get(
        'new_modal_exceed_upload_limit_button_close'
      )}>
      <Box data-testid="modal-child-box" sx={{ maxWidth: 'md' }}>
        <MDTypography variant="h6">
          {intl.get('new_modal_exceed_upload_limit_message_3')}
        </MDTypography>
      </Box>
    </ConfirmModal>
  );
};

ExceededLimitModal.propTypes = propTypes;

export default ExceededLimitModal;
